import React from "react";

import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="min-h-screen mesh-bg">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <Link to="/" className="text-sm text-emerald-600">
          ← Back to home
        </Link>

        <div className="card-soft p-8 mt-6">
          <h1 className="font-display text-4xl font-bold">Privacy Policy</h1>

          <p className="mt-2 text-sm text-slate-500">Last updated: May 2026</p>

          <div className="prose prose-slate dark:prose-invert max-w-none mt-8">
            <section className="space-y-4">
              <h2 className="text-2xl font-bold">1. Introduction</h2>

              <p>
                AccessWealth ("we", "our", or "us") provides digital wealth
                organization, financial tracking, nominee management,
                inheritance planning, vault storage, and related financial
                management services.
              </p>

              <p>
                This Privacy Policy explains how we collect, use, store, and
                protect your information when you use the AccessWealth website,
                mobile applications, and related services.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">2. Information We Collect</h2>

              <p>We may collect the following categories of information:</p>

              <ul className="space-y-2">
                <li>Full name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Authentication and login activity</li>
                <li>Financial asset and liability information</li>
                <li>Nominee and inheritance allocation data</li>
                <li>Vault documents uploaded by users</li>
                <li>Device and browser metadata</li>
                <li>IP address and security logs</li>
              </ul>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">
                3. How We Use Your Information
              </h2>

              <p>Your information is used to:</p>

              <ul className="space-y-2">
                <li>Provide financial tracking services</li>
                <li>Maintain account security and authentication</li>
                <li>Enable nominee and family linking features</li>
                <li>Generate financial projections and analytics</li>
                <li>Provide customer support</li>
                <li>Improve application performance and reliability</li>
                <li>Prevent fraud, abuse, and unauthorized access</li>
              </ul>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">
                4. Family & Inheritance Disclaimer
              </h2>

              <p>
                AccessWealth does not independently verify legal family
                relationships, nominee claims, inheritance rights, ownership
                claims, wills, or legal succession validity.
              </p>

              <p>
                Family links, nominees, allocations, and inheritance
                distributions are based solely on information entered by users.
              </p>

              <p>
                Users are fully responsible for ensuring the accuracy and
                legality of information entered into the platform.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">5. Vault Documents</h2>

              <p>
                Users may upload sensitive documents to the digital vault
                feature. AccessWealth applies industry-standard security
                practices to protect stored files, but users remain responsible
                for the legality and ownership of uploaded documents.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">6. Data Security</h2>

              <p>
                We use industry-standard administrative, technical, and
                organizational safeguards to protect user information, including
                encrypted communication channels, authentication protections,
                and secure infrastructure practices.
              </p>

              <p>
                However, no method of electronic storage or internet
                transmission is completely secure, and we cannot guarantee
                absolute security.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">7. Third-Party Services</h2>

              <p>
                AccessWealth may use trusted third-party providers for
                infrastructure, analytics, authentication, email delivery,
                payment processing, and cloud hosting services.
              </p>

              <p>
                These providers may process limited information necessary for
                service functionality.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">8. Cookies & Sessions</h2>

              <p>
                We may use cookies, authentication tokens, and session
                technologies to maintain secure login sessions and improve user
                experience.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">9. Data Retention</h2>

              <p>
                We retain user information only for as long as necessary to
                provide services, comply with legal obligations, resolve
                disputes, and enforce platform policies.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">10. Account Deletion</h2>

              <p>
                Users may request account deletion by contacting support or
                using available in-app account deletion tools.
              </p>

              <p>
                Upon verified deletion requests, we will remove or anonymize
                user data within a reasonable timeframe unless retention is
                legally required.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">11. Your Rights</h2>

              <p>Depending on your jurisdiction, you may have rights to:</p>

              <ul className="space-y-2">
                <li>Access your personal data</li>
                <li>Correct inaccurate information</li>
                <li>Request deletion of your account</li>
                <li>Export your data</li>
                <li>Withdraw consent where applicable</li>
              </ul>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">12. Children's Privacy</h2>

              <p>
                AccessWealth is not intended for individuals under the age of
                18. We do not knowingly collect personal information from
                minors.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">13. Policy Updates</h2>

              <p>
                We may update this Privacy Policy periodically. Continued use of
                the platform after updates constitutes acceptance of the revised
                policy.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">14. Contact</h2>

              <p>
                For privacy concerns, security issues, or account deletion
                requests, contact:
              </p>

              <p className="font-semibold text-emerald-600">
                info@accesswealth.in
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
